import { render, staticRenderFns } from "./SubPage.vue?vue&type=template&id=23573a03&scoped=true"
import script from "./SubPage.vue?vue&type=script&lang=js"
export * from "./SubPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23573a03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23573a03')) {
      api.createRecord('23573a03', component.options)
    } else {
      api.reload('23573a03', component.options)
    }
    module.hot.accept("./SubPage.vue?vue&type=template&id=23573a03&scoped=true", function () {
      api.rerender('23573a03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/SubPage.vue"
export default component.exports